import { Fragment, useRef } from 'react';
import { useLang } from '../../../i18n';
import useIntersectionFadeIn from '../../../hooks/useIntersectionFadeIn';

interface Principle { num: string; title: string; body: string }

export default function ApproachSection() {
  const { t } = useLang();
  const rootRef = useRef<HTMLElement>(null);
  const visible = useIntersectionFadeIn(rootRef);

  const principles: Principle[] = [
    { num: '01', title: t('home.approach.p1.t'), body: t('home.approach.p1.d') },
    { num: '02', title: t('home.approach.p2.t'), body: t('home.approach.p2.d') },
    { num: '03', title: t('home.approach.p3.t'), body: t('home.approach.p3.d') },
    { num: '04', title: t('home.approach.p4.t'), body: t('home.approach.p4.d') },
    { num: '05', title: t('home.approach.p5.t'), body: t('home.approach.p5.d') },
    { num: '06', title: t('home.approach.p6.t'), body: t('home.approach.p6.d') },
  ];

  const rows: Principle[][] = [];
  for (let i = 0; i < principles.length; i += 2) {
    rows.push(principles.slice(i, i + 2));
  }

  return (
    <section ref={rootRef} className={`section section--surface-2 approach scroll-fade-in${visible ? ' scroll-fade-in--visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <span className="eyebrow">{t('home.approach.eyebrow')}</span>
          <h2>{t('home.approach.title')}</h2>
          <p className="lead">{t('home.approach.sub')}</p>
        </header>

        <div className="approach__rows">
          {rows.map((row, rowIdx) => (
            <Fragment key={row[0].num}>
              <div className="approach__row">
                {row.map((p) => (
                  <article key={p.num} className="approach__item">
                    <span className="tech-label approach__label">PRINCIPLE / {p.num}</span>
                    <h3 className="approach__title">{p.title}</h3>
                    <p className="approach__body">{p.body}</p>
                  </article>
                ))}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
